(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haveltea-values"] && !Shopify.designMode) return;
  try {
    
  class HavelteaCarousel {
    constructor(element) {
      this.carousel = element;
      this.track = this.carousel.querySelector('.haveltea-carousel__track');
      this.slides = this.carousel.querySelectorAll('.haveltea-carousel__slide');
      this.dots = this.carousel.querySelectorAll('.haveltea-carousel__dot');
      this.currentSlide = 0;
      this.startX = 0;
      this.currentX = 0;
      this.isDragging = false;
      this.autoplayInterval = null;
      this.autoplayDelay = 4000; 

      this.init();
      this.startAutoplay();
    }

    init() {
      this.dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          const slideIndex = parseInt(e.target.dataset.slide);
          this.goToSlide(slideIndex);
          this.resetAutoplay(); 
        });
      });

      this.track.addEventListener('touchstart', (e) => {
        this.startX = e.touches[0].clientX;
        this.isDragging = true;
        this.track.style.transition = 'none';
        this.stopAutoplay(); 
      }, { passive: true });

      this.track.addEventListener('touchmove', (e) => {
        if (!this.isDragging) return;
        this.currentX = e.touches[0].clientX;
        const diff = this.currentX - this.startX;
        const currentOffset = -this.currentSlide * 100;
        const dragPercent = (diff / this.track.offsetWidth) * 100;
        this.track.style.transform = `translateX(${currentOffset + dragPercent}%)`;
      }, { passive: true });

      this.track.addEventListener('touchend', () => {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.track.style.transition = 'transform 0.3s ease';
        
        const diff = this.startX - this.currentX;
        
        if (Math.abs(diff) > 50) {
          if (diff > 0 && this.currentSlide < this.slides.length - 1) {
            this.goToSlide(this.currentSlide + 1);
          } else if (diff < 0 && this.currentSlide > 0) {
            this.goToSlide(this.currentSlide - 1);
          } else {
            this.goToSlide(this.currentSlide);
          }
        } else {
          this.goToSlide(this.currentSlide);
        }
        
        this.resetAutoplay(); 
      });

      this.track.addEventListener('mousedown', (e) => {
        this.startX = e.clientX;
        this.isDragging = true;
        this.track.style.cursor = 'grabbing';
        this.track.style.transition = 'none';
        this.stopAutoplay(); 
        e.preventDefault();
      });

      this.track.addEventListener('mousemove', (e) => {
        if (!this.isDragging) return;
        this.currentX = e.clientX;
        const diff = this.currentX - this.startX;
        const currentOffset = -this.currentSlide * 100;
        const dragPercent = (diff / this.track.offsetWidth) * 100;
        this.track.style.transform = `translateX(${currentOffset + dragPercent}%)`;
      });

      this.track.addEventListener('mouseup', () => {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.track.style.cursor = 'grab';
        this.track.style.transition = 'transform 0.3s ease';
        
        const diff = this.startX - this.currentX;
        
        if (Math.abs(diff) > 50) {
          if (diff > 0 && this.currentSlide < this.slides.length - 1) {
            this.goToSlide(this.currentSlide + 1);
          } else if (diff < 0 && this.currentSlide > 0) {
            this.goToSlide(this.currentSlide - 1);
          } else {
            this.goToSlide(this.currentSlide);
          }
        } else {
          this.goToSlide(this.currentSlide);
        }
        
        this.resetAutoplay(); 
      });

      this.track.addEventListener('mouseleave', () => {
        if (this.isDragging) {
          this.isDragging = false;
          this.track.style.cursor = 'grab';
          this.track.style.transition = 'transform 0.3s ease';
          this.goToSlide(this.currentSlide);
          this.resetAutoplay(); 
        }
      });
    }

    goToSlide(index) {
      this.currentSlide = index;
      const offset = -index * 100;
      this.track.style.transform = `translateX(${offset}%)`;

      this.dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        let nextSlide = this.currentSlide + 1;
        
        if (nextSlide >= this.slides.length) {
          nextSlide = 0;
        }
        
        this.goToSlide(nextSlide);
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.haveltea-carousel');
    carousels.forEach(carousel => new HavelteaCarousel(carousel));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-make-matcha"] && !Shopify.designMode) return;
  try {
    
  class MatchaGuideTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('.matcha-guide__tab');
      this.panels = this.querySelectorAll('.matcha-guide__panel');
      
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.switchTab(tab));
      });
    }

    switchTab(selectedTab) {
      const tabIndex = selectedTab.dataset.tabIndex;

      // Update tabs
      this.tabs.forEach(tab => {
        tab.classList.remove('matcha-guide__tab--active');
        tab.setAttribute('aria-selected', 'false');
      });
      selectedTab.classList.add('matcha-guide__tab--active');
      selectedTab.setAttribute('aria-selected', 'true');

      // Update panels
      this.panels.forEach(panel => {
        panel.classList.remove('matcha-guide__panel--active');
        panel.hidden = true;
      });

      const selectedPanel = this.querySelector(`[data-panel-index="${tabIndex}"]`);
      if (selectedPanel) {
        selectedPanel.classList.add('matcha-guide__panel--active');
        selectedPanel.hidden = false;
      }
    }
  }

  customElements.define('matcha-guide-tabs', MatchaGuideTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
